
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/487db9400d4b128acf15ab7b99a2c23a.jpg"
          alt="Professional Legal Technology"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A1F2E]/95 via-[#1A1F2E]/90 to-[#2A3142]/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="mb-6">
              <span className="text-[#e10708] text-sm uppercase tracking-widest font-light">
                The Strategic Legal Partner
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-serif leading-tight mb-6">
              <span className="text-white block mb-2">Protecting the Privilege.</span>
              <span className="text-white/90 block">Powering the Billable Hour.</span>
            </h1>

            <p className="text-xl lg:text-2xl text-white/90 mb-4 max-w-4xl mx-auto leading-relaxed font-light">
              As a law firm partner or administrator, your reputation is built on two things: your expertise and your discretion. A technology failure isn&apos;t just an inconvenience; it&apos;s a threat to your fiduciary duty and your bottom line.
            </p>

            <p className="text-lg lg:text-xl text-white/80 mb-12 max-w-4xl mx-auto leading-relaxed">
              Our <strong>IT services for law firms</strong> provide <strong>MSP services for law firms</strong> with Fractional CTO and Security Governance designed specifically for the high-stakes environment of modern law. We deliver comprehensive <strong>IT solutions for law firms</strong>, <strong>cybersecurity for law firms</strong>, and <strong>cyber insurance and compliance for law firms</strong>.
            </p>

            <div className="flex flex-wrap gap-4">
              <a 
                href="#contact"
                className="bg-[#e10708] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#c10607] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap inline-flex items-center"
              >
                <span>Get Started</span>
                <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a 
                href="#problems"
                className="border-2 border-white/30 text-white px-8 py-4 rounded-full text-base font-semibold hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="hidden lg:flex items-center justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-[#e10708]/20 blur-3xl rounded-full"></div>
              <div className="relative w-96 h-96 flex items-center justify-center">
                <i className="ri-shield-check-fill text-[#e10708] opacity-90" style={{ fontSize: '20rem' }}></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center animate-bounce">
          <span className="text-white/60 text-xs uppercase tracking-wider mb-2">Scroll</span>
          <i className="ri-arrow-down-line text-white/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
        </div>
      </div>
    </section>
  );
}
